import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyLenses } from "src/app/models/company-lenses.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class CompanyLensesService extends BaseService {
  
    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/company-lenses');
    }

    
  getLenses(visionType?: string) {
    let url = `${this.apiUrl}`;

    if (visionType) {
      url += `?visionType=${visionType}`;
    }
    
    return this.http.get<CompanyLenses[]>(url);
  }

}
